import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Button } from "react-bootstrap";
import { accountServices } from "../../../APIServices/GlobalManagements/accountServices";
import { propertyServices } from "../../../APIServices/GlobalManagements/propertyServices";
import Swal from "sweetalert2";

const UpdateProperty = ({ show, hide, title, getPropertyList, propertyData, organizationList, currentUserData }) => {
  const [loader, setLoader] = useState(false);
  const [name, setName] = useState("");
  const [domain, setDomain] = useState("");
  const [accountId, setAccountId] = useState("");
  const [accountList, setAccountList] = useState([]);
  const [status, setStatus] = useState("");

  const updatedProperty = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update this property?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true)
        let userData = {}
        userData.propertyId = propertyData?.propertyId
        userData.name = name
        userData.domain = domain
        if(currentUserData?.roleType === "organization"){
          userData.accountId = accountId
        }
        userData.status = status
        let data = await propertyServices.updatedProperty(userData)
        if (data?.statusCode === 200) {
          getPropertyList()
          clearData();
        }
        setLoader(false)
      }
    });
  };

  const clearData = () => {
    setName("");
    setDomain("");
    setAccountId("");
    setStatus("");
    setLoader(false)
    hide();
  }

  const getAccountList = async (adminId) => {
    let data = await accountServices.getAccountList(adminId, "active")
    setAccountList(data?.data || [])
  }

  useEffect(() => {
    if (show && propertyData) {
      setName(propertyData?.name);
      setDomain(propertyData?.domain || "");
      setStatus(propertyData?.status);
      setAccountId(propertyData?.accountId);
      setLoader(false)
      if (organizationList?.length === 1) {
        getAccountList(organizationList?.[0]?.adminId)
      }
    }
  }, [show, propertyData, organizationList]);

  return (
    <Offcanvas show={show} onHide={hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form>
          {currentUserData?.roleType === "organization" &&
            <Form.Group className="mb-2">
              <Form.Label>Account</Form.Label>
              <Form.Select
                name="account"
                value={accountId}
                onChange={(e) => setAccountId(e.target.value)}
              >
                <option value="">Select Account</option>
                {accountList?.map(item => (
                  <option value={item?.accountId}>{item?.name}</option>
                ))}
              </Form.Select>
            </Form.Group>
          }
          <Form.Group className="mb-2">
            <Form.Label>
              Website / App Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="userName"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter Website / App name"
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Domain
            </Form.Label>
            <Form.Control
              name="userName"
              value={domain}
              onChange={(e) => setDomain(e.target.value)}
              placeholder="Enter Domain name (URL)"
            />
          </Form.Group>
          <Form.Group className="mb-2">
            <Form.Label>
              Status <span className="text-danger">*</span>
            </Form.Label>
            <Form.Select
              className="interactive-input"
              style={{ fontSize: 14 }}
              onChange={(e) => setStatus(e.target.value)}
              value={status}
            >
              <option value="">Select Status</option>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </Form.Select>
          </Form.Group>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button style={{ fontSize: 12 }} variant="light" onClick={clearData}>
              Cancel
            </Button>
            <Button
              disabled={currentUserData?.roleType === "organization" ? (!accountId || !name || loader) : (!name || loader)}
              onClick={updatedProperty}
              style={{ fontSize: 12 }}>
              {title}
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default UpdateProperty;
